<!--  -->
<template>
  <div class="love-container">
    <div class="top-nav">
      <div class="navs">
        <div class="nav active" @click="changeBar(1)">
          愿望清单(
          <span>{{wishtList.length}}</span>)
        </div>
      </div>
      <!-- <div class="herf_tilte add-love" @click="showList = true">新增清单</div> -->
    </div>
    <div class="small_loading" v-if="loading">
      <img src="../assets/image/icon/small_loading.gif" />
    </div>
    <div v-else>
      <div class="data-list goods-list" v-if="wishtList.length>0">
        <div class="save-content" v-for="(item,index) in wishtList" :key="index">
          <div class="save-item">
            <div class="cart-left">
              <div class="cart-img" @click="goPage(item.baseDTO.friendlyUrl,item.baseDTO,index)">
                <img v-real-img="item.baseDTO.imageList[0].originalUrl" />
              </div>

              <div class="cart-info">
                <div class="cart-info-detail">
                  <div class="good-name">
                    <span>{{item.baseDTO.name}}</span>
                    <!-- // 状态 : 0-正常; 1-下架; 2-售罄 3-库存紧张4-预售; -->
                    <span
                      class="last-pro"
                      v-if="(item.status==0||item.status==3)&&item.skuStock==1"
                    >最后一件</span>
                    <span class="last-pro" v-if="item.status==1">已下架</span>
                    <span class="last-pro" v-if="item.status==2">售罄</span>
                  </div>

                  <div class="good-size" v-if="item.skuValue&&item.skuId&&!needUpdate">
                    尺码.
                    <span
                      class="value"
                      v-if="item.skuValue&&item.skuValue2&&item.skuValue3"
                    >{{item.skuValue}}；{{item.skuValue2}};{{item.skuValue3}}</span>
                    <span
                      class="value"
                      v-else-if="item.skuValue&&item.skuValue2"
                    >{{item.skuValue}}；{{item.skuValue2}}</span>
                    <span class="value" v-else-if="item.skuValue">{{item.skuValue}}</span>
                  </div>

                  <div
                    class="good-size"
                    v-else
                    v-for="(gitem,gindex) in item.guigeList"
                    :key="gindex"
                  >
                    {{gitem.name}}.
                    <span
                      class="value"
                      v-if="gindex == 0"
                    >{{ item.skuValue ? item.skuValue:'选择'+gitem.name}}</span>

                    <span
                      class="value"
                      v-if="gindex == 1"
                    >{{ item.skuValue2 ? item.skuValue2:'选择'+gitem.name}}</span>
                    <span
                      class="value"
                      v-if="gindex == 2"
                    >{{ item.skuValue3 ? item.skuValue3:'选择'+gitem.name}}</span>

                    <Select
                      class="test"
                      style="width:3rem"
                      :label-in-value="true"
                      @on-change="change_status(index,gindex)"
                      v-model="item.skuValue"
                      v-if="gindex == 0"
                    >
                      <Option
                        v-for="(item,indexskuValue) in gitem.childs"
                        :key="indexskuValue"
                        :label="index"
                        :value="item.value"
                        :disabled="item.isgray"
                      >{{ item.value }}</Option>
                    </Select>
                    <Select
                      style="width:3rem"
                      :label-in-value="true"
                      @on-change="change_status(index,gindex)"
                      v-model="item.skuValue2"
                      v-if="gindex == 1"
                    >
                      <Option
                        v-for="(item,indexskuValue2) in gitem.childs"
                        :key="indexskuValue2"
                        :label="index"
                        :value="item.value"
                        :disabled="item.isgray"
                      >{{ item.value }}</Option>
                    </Select>
                    <Select
                      style="width:3rem"
                      :label-in-value="true"
                      @on-change="change_status(index,gindex)"
                      v-model="item.skuValue3"
                      v-if="gindex == 2"
                    >
                      <Option
                        v-for="(item,indexskuValue3) in gitem.childs"
                        :key="indexskuValue3"
                        :label="index"
                        :value="item.value"
                        :disabled="item.isgray"
                      >{{ item.value }}</Option>
                    </Select>
                  </div>
                  <div class="good-color">
                    颜色.
                    <span class="value">{{item.baseDTO.colorText}}</span>
                  </div>
                  <div class="good-num" v-if="item.skuValue&&item.skuId&&!needUpdate">
                    数量.
                    <span class="value">{{item.checkNu}}</span>
                  </div>

                  <div class="good-num" v-else>
                    数量.
                    <span class="value">{{item.checkNu}}</span>
                    <Select
                      v-if="stocknum>0&&chooseIndex==index"
                      style="width:3rem"
                      @on-change="updateStockNum"
                      :label-in-value="true"
                      v-model="item.checkNu"
                    >
                      <Option
                        v-for="(item,stocknumindex) in stocknum"
                        :key="stocknumindex"
                        :label="index"
                        :value="item"
                      >{{ item }}</Option>
                    </Select>
                  </div>
                  <!-- 选择了sku的去item的discountPrice-->
                  <div class="good-price" v-if="item.skuId">
                    价格.
                    <template v-if="item.discountPrice!='0'&&item.discountPrice!=undefined">
                      <span
                        class="originprice"
                        style="padding-right
                    :.5rem;"
                      >¥{{$utils.toThousands(item.price) }}</span>
                      <span class="currprice">¥{{$utils.toThousands(item.discountPrice)}}</span>
                    </template>

                    <template v-else>
                      <span class="currprice">¥{{$utils.toThousands(item.price)}}</span>
                    </template>
                  </div>
                  <!-- 选择了sku的去item的discountPrice-->
                  <!-- 没有选择sku取item.baseDTO的discountPrice-->
                  <div class="good-price" v-else>
                    <template
                      v-if="item.baseDTO.discountPrice!='0'&&item.baseDTO.discountPrice!=undefined"
                    >
                      价格.
                      <span
                        class="originprice"
                        style="padding-right
                    :.5rem;"
                      >¥{{$utils.toThousands(item.baseDTO.price) }}</span>
                      <span class="currprice">¥{{$utils.toThousands(item.baseDTO.discountPrice)}}</span>
                    </template>

                    <template v-else>
                      <div class="currprice">¥{{$utils.toThousands(item.baseDTO.price)}}</div>
                    </template>
                    <!-- 没有选择sku取item.baseDTO的discountPrice-->
                  </div>

                  <!-- stocknum -->
                  <!-- <div class="good-num" v-else> -->
                  <!-- 数量. -->
                  <!-- <span class="value">{{item.checkNu}}</span> -->
                  <!-- <Select
                    style="width:3rem"
                    :label-in-value="true"
                    @on-change="change_status(index,gindex)"
                    v-model="item.skuValue3"
                    v-if="gindex == 0"
                  >
                    <Option
                      v-for="(item,indexskuValue3) in guigeList[chooseIndex]"
                      :key="indexskuValue3"
                      :label="index"
                      :value="item.stocknum"
                    >{{ item.stocknum }}</Option>
                  </Select>-->
                  <!-- </div> -->

                  <div
                    class="add-whish herf_tilte"
                    v-if="item.status == 0 || item.status ==3"
                    @click="addCart(index,item)"
                  >移至购物袋</div>
                  <div class="mb-remove herf_tilte" @click="cancleWish(index)">移除</div>
                </div>
                <div class="cart-price">
                  <!-- 选择了sku的去item的discountPrice-->
                  <template v-if="item.skuId">
                    <template v-if="item.discountPrice!='0'&&item.discountPrice!=undefined">
                      <div class="originprice">¥{{$utils.toThousands(item.price) }}</div>
                      <div class="currprice">¥{{$utils.toThousands(item.discountPrice)}}</div>
                    </template>
                    <template v-else>
                      <div class="currprice">¥{{$utils.toThousands(item.price)}}</div>
                    </template>
                  </template>
                  <!-- 选择了sku的去item的discountPrice-->
                  <!-- 没有选择sku取item.baseDTO的discountPrice-->
                  <template v-else>
                    <template
                      v-if="item.baseDTO.discountPrice!='0'&&item.baseDTO.discountPrice!=undefined"
                    >
                      <div class="originprice">¥{{$utils.toThousands(item.baseDTO.price) }}</div>
                      <div class="currprice">¥{{$utils.toThousands(item.baseDTO.discountPrice)}}</div>
                    </template>
                    <template v-else>
                      <div class="currprice">¥{{$utils.toThousands(item.baseDTO.price)}}</div>
                    </template>
                    <!-- 没有选择sku取item.baseDTO的discountPrice-->
                  </template>
                  <div class="remove herf_tilte" @click="cancleWish(index)">移除</div>
                </div>
              </div>
            </div>
            <div class="cart-right"></div>
          </div>
          <div class="hint" v-if="ishasskuid &&chooseIndex==index">请选择规格</div>
        </div>
      </div>
      <div class="no-data" v-if="wishtList.length<=0">您的愿望清单中暂无数据</div>
    </div>
  </div>
</template>

<script>
import { checkLinkUrl, setHeaderTop } from "../utils/utils";
import AddList from "./common/AddList";
import "../assets/style/order.less";
export default {
  data() {
    return {
      needUpdate: false,
      stocknum: 0,
      loaded: false,
      chooseIndex: null,
      ishasskuid: false,
      wishtList: [],
      choosesize: "",
      chooseskuSpecValue0: "",
      chooseskuSpecValue1: "",
      chooseskuSpecValue2: "",
      API: this.$store.state.API,
      showList: false,
      loading: true
    };
  },
  components: { AddList },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    document.title = "愿望清单" + this.$store.state.titleSuffix;
    this.getMyWishList();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  beforeRouteLeave(to, from, next) {
    var state_2 = this.$store.state.RefreshAcountNav;
    this.$store.commit("RefreshAcountNav", !state_2);
    next(true);
  },
  mounted() {
    this.$utils.setPathsbysessionStorage(window.location.href)
    this.$gaAction.pageview(document.title, this.$route.path);
  },
  methods: {
    getLoginStatus() {
      const that = this;
      return new Promise((resolve, reject) => {
        this.hasLogin = window.localStorage.getItem("token") ? false : true;
        resolve(this.hasLogin);
      });
    },
    //根据规格属性获取库存和价格
    getskuprice: function(data) {
      var that = this;
      // 去获取skuid
      return new Promise((resolve, reject) => {
        //参数部分
        var url = this.$store.state.API.pdp.getStocksAndPriceByType,
          params = {
            productId: data.productId,
            imageSpecId: data.imageSpecId,
            extraSpecId1: data.extraSpecId1,
            extraSpecId2: data.extraSpecId2,
            imageSpecValue: data.skuImageValue,
            extraSpecValue1: data.skuSpecValue1,
            extraSpecValue2: data.skuSpecValue2,
            openId: this.$store.state.openId || this.$store.state.userId
          };
        this.$http
          .post(url, that.$qs.stringify(params))
          .then(res => {
            if (res.data.returnData) {
              that.stocknum = res.data.returnData.stocks;
              that.goodsprice = parseFloat(res.data.returnData.price);
              that.discountprice = res.data.returnData.distributionPrice
                ? res.data.returnData.distributionPrice
                : parseFloat(res.data.returnData.discountPrice);
              that.skuid = res.data.returnData.id;

              that.ishasskuid = false;
              that.Taxes = 0;
              resolve(that.skuid);
            } else {
              this.ishasskuid = true;
              reject(res.data.message);
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    async updateStockNum(data) {
      if (!data) {
        return;
      }
      this.choosenum = data.value;
      this.cancleWish(this.chooseIndex, "update"); //修改x/
    },
    async change_status(index, gindex) {
      this.chooseIndex = index;
      var item = this.wishtList[index];
      var data = {
        productId: item.baseDTO.id,
        imageSpecId: item.guigeList[0] ? item.guigeList[0].id : "",
        extraSpecId1: item.guigeList[1] ? item.guigeList[1].id : "",
        extraSpecId2: item.guigeList[2] ? item.guigeList[2].id : "",
        skuImageValue: item.skuValue,
        skuSpecValue1: item.skuValue2,
        skuSpecValue2: item.skuValue3
      };
      this.updateSkuId = await this.getskuprice(data);
      this.wishtList[index].skuId = this.updateSkuId;
      this.needUpdate = true;
      // if (this.updateSkuId) {
      //   this.cancleWish(index, "update"); //修改
      // }
    },
    goPage(linkUrl, good, index) {
      this.$router.push({
        name: "shopping",
        params: {
          friendly_url: linkUrl
        }
      });
      this.gaSelectContent(good, index);
    },
    //加入购物车
    async addCart(index, goodInfo) {
      this.gaAddToCart(goodInfo.baseDTO);
      let url = this.API.shopcart.addCart;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      var item = this.wishtList[index];
      this.chooseIndex = index;
      if (!item.skuId) {
        this.ishasskuid = true;
        return false;
      }
      let params = {
        openId: OpenId || this.$store.state.userId,
        skuId: item.skuId,
        count: item.checkNu,
        pageUrl: item.baseDTO.friendly_url,
        terminal: "WEB",
        sourceTb:'website',
        source: "website",
        imageUrl: ""
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.ishasskuid = false;
            let state_1 = this.$store.state.shopCartFalg;
            let state_2 = this.$store.state.RefreshShopCart;
            this.$store.commit("showShopCartPop", !state_1);
            // this.$Message.success("加入购物车成功");

            this.$store.commit("RefreshShopCart", !state_2);
            this.cancleWish(index);
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
      console.log(params, "加入购物车");
    },
    //移除
    async cancleWish(index, type) {
      let url = this.API.my.addWish;
      var item = this.wishtList[index];
      var params = {};
      if (type == "update") {
        params = {
          merchantId: this.$store.state.storeId,
          openId: this.$store.state.openId || this.$store.state.userId,
          productId: item.id,
          skuId: this.updateSkuId,
          id: item.id,
          skuImageValue: item.skuValue,
          skuSpecValue1: item.skuValue2,
          skuSpecValue2: item.skuValue3,
          skuNu: this.choosenum ? this.choosenum : item.skuNu,
          flag: 0 //0：收藏，1：取消收藏
        };
      } else {
        params = {
          merchantId: this.$store.state.storeId,
          openId: this.$store.state.openId || this.$store.state.userId,
          productId: item.id,
          skuId: item.skuid,
          id: item.id,
          skuImageValue: item.skuValue,
          skuSpecValue1: item.skuValue2,
          skuSpecValue2: item.skuValue3,
          skuNu: 1,
          flag: 1 //0：收藏，1：取消收藏
        };
      }

      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result && res.data.message == "success") {
            this.needUpdate = false;
            let state_2 = this.$store.state.RefreshLoveList;
            this.$store.commit("RefreshLoveList", !state_2);
            this.getMyWishList();

            if (type == "update") {
            } else {
              // this.$Message.success("移除成功");
            }
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },

    getMyWishList() {
      // /dbc/mini/collection/list
      var openId = this.$store.state.openId || this.$store.state.userId;
      let url =
        this.API.my.getWishList +
        "?merchantId=" +
        this.$store.state.storeId +
        "&openId=" +
        openId;
      this.$http
        .get(url, {})
        .then(res => {
          if (res.data.result) {
            let list = [];
            let skus = res.data.returnData.skus;
            let invalidSkus = res.data.returnData.invalidSkus;
            list = skus.concat(invalidSkus);
            this.wishtList = list;
            this.getGaData(this.wishtList);
            this.$utils.updateImgOssSuffix(this); //检测是否支持webp格式

            for (var m = 0; m < this.wishtList.length; m++) {
              var guigelist = JSON.parse(this.wishtList[m].skuSpec).dtos;
              // 需要变灰的sku
              var guigestocklist = JSON.parse(this.wishtList[m].skuSpec)
                .garyDtos;

              if (guigestocklist.length <= 0) {
                //当没有库存信息时
                for (var n = 0; n < guigelist.length; n++) {
                  for (var j = 0; j < guigelist[n].childs.length; j++) {
                    guigelist[n].childs[j].isgray = true;
                  }
                }
                this.wishtList[m].guigeList = guigelist;
                setTimeout(() => {
                  this.loading = false;
                }, 1000);
              } else {
                for (var i = 0; i < guigelist.length; i++) {
                  for (var k = 0; k < guigestocklist.length; k++) {
                    if (guigelist[i].id == guigestocklist[k].categryId) {
                      for (var j = 0; j < guigelist[i].childs.length; j++) {
                        if (
                          guigelist[i].childs[j].value ==
                          guigestocklist[k].categryValue
                        ) {
                          if (guigestocklist[k].status == "1") {
                            guigelist[i].childs[j].isgray = false;

                            guigelist[i].childs[j].stocknum =
                              guigestocklist[k].stock;
                          } else {
                            guigelist[i].childs[j].ischk = false;
                            guigelist[i].childs[j].isgray = true;
                            guigelist[i].childs[j].stocknum = 0;
                          }
                        }
                      }
                    }
                  }
                }
                this.wishtList[m].guigeList = guigelist;
                setTimeout(() => {
                  this.loading = false;
                }, 1000);
              }
            }
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
    handleUser() {
      this.showList = false;
    },
    changeBar(type) {
      this.type = type;
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    getGaData(dataList) {
      if (dataList.length != 0) {
        console.log(dataList);
        let gaData = [];
        for (let i in dataList) {
          gaData.push(dataList[i].baseDTO);
        }
        console.log(gaData);
        this.$gaAction.view_item(gaData, "love_list_my");
      }
    },
    //GA select_content埋点
    gaSelectContent(good, index) {
      this.$set(good, "list_position", index);
      this.$set(good, "list_name", "love_list_my");
      this.$gaAction.select_content(good);
    },
    //GA add_to_cart埋点
    gaAddToCart(gaData) {
      this.$gaAction.add_to_cart(gaData, "love_list_my");
    }
  }
};
</script>
<style scoped lang='less'>
/* @import url(); 引入css类 */
.love-container {
  position: relative;
  .top-nav {
    padding: 1.6rem 0;
    display: flex;
    flex: 1;
    font-size: 1.2rem;
    line-height: 1.67;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.1rem solid #e5e5e5;
    .add-love {
      padding-right: 2rem;
      cursor: pointer;
    }
    .navs {
      display: flex;
      .nav {
        min-width: 7rem;
        min-height: 2.4rem;
        padding: 0rem 2rem;
        display: flex;
        align-items: center;
        color: #959595;
        font-size: 1.2rem;
        font-weight: 400;
        text-transform: uppercase;
        cursor: pointer;
        &.active {
          color: #5c5d5f;
        }
      }
    }
  }
  .data-list {
    &.goods-list {
      .save-content {
        .save-item {
          display: flex;
          border-bottom: 0.1rem solid #e5e5e5;
          &:last-child {
            border-bottom: none;
          }
          .cart-left {
            position: relative;
            padding: 2rem;
            display: flex;
            flex: 3;
            .cart-img {
              display: block;
              cursor: pointer;
              .hint {
                height: 1.8rem;
                padding-top: 1rem;
                color: #d0021b;
              }
              img {
                width: 10.5rem;
              }
            }
            .cart-info {
              width: 100%;
              display: flex;
              justify-content: space-between;
              padding: 1rem 0 0 2rem;
              color: #8e8f8b;
              font-size: 1.2rem;
              line-height: 1.67;

              .add-whish {
                // position: absolute;
                // bottom: 2rem;
                margin-top: 1rem;
                color: #5c5d5f;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .mb-remove {
                color: #5c5d5f;
                cursor: pointer;
                display: none;
                &:hover {
                  text-decoration: underline;
                }
              }
              .remove {
                right: 2rem;
                position: absolute;
                bottom: 2rem;
                color: #5c5d5f;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .cart-info-detail {
                text-align: left;
                .value {
                  color: #5c5d5f;
                  margin-right: 0.5rem;
                }
                .good-name {
                  margin-bottom: 1.4rem;
                  display: flex;
                  // justify-content: center;
                  align-items: center;
                  .last-pro {
                    padding: 0rem 1.4rem;
                    border: 0.1rem solid #5c5d5f;
                    text-transform: none;
                    white-space: nowrap;
                    color: #5c5d5f;
                    margin-left: 0.6rem;
                  }
                }
                .good-color,
                .good-size {
                  margin-bottom: 0.3rem;
                }

                .good-num {
                  // margin-bottom: 1.6rem;
                }
                .good-price {
                  display: none;
                }
              }
              .cart-price {
                text-align: right;
              }
            }
          }
          .cart-right {
          }
        }
        .hint {
          padding: 0rem 2rem 2rem;
          margin-top: -1rem;
          color: #d0021b;
        }
      }
    }
    &.love-list {
      .love-item {
        display: flex;
        padding: 2rem;
        border-top: 0.1rem solid #e5e5e5;
        .love-left {
          width: 20%;
          .num {
            margin-bottom: 2rem;
          }
          .save {
            display: flex;
            line-height: 1.67;

            .cancle {
              cursor: pointer;
              margin-left: 0.5rem;
            }
          }
          .herf_tilte {
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .love-right {
          margin-right: 2rem;
          .love-img {
            width: 11rem;
            margin-left: 2rem;
          }
        }
      }
    }
  }
  .no-data {
    padding: 1.6rem 2rem;
  }
}

@media screen and (max-width: 1024px) {
  .love-container .top-nav {
    // border: 0.1rem solid #e5e5e5;
    margin-bottom: 2rem;
  }
  .love-container .data-list {
    // border-top: 0.1rem solid #e5e5e5;
  }
  .love-container .data-list.goods-list .save-content {
    // border: 0.1rem solid #e5e5e5;
    border-top: none;
  }
  .love-container .data-list.goods-list .save-content .save-item {
    border: none;
  }
}
@media screen and (max-width: 768px) {
  .love-container {
    padding-bottom: 2rem;
    .top-nav {
      border: none;
      margin-bottom: 0rem;
      display: none;
    }
    .no-data {
      border-top: 0.1rem solid #e5e5e5;
    }

    .data-list.goods-list .save-content {
      border: none;
      border-bottom: 0.1rem solid #e5e5e5;
    }
    .data-list.goods-list .save-content .save-item {
      border: none;
    }
    .goods-list {
      padding-bottom: 5rem;
      border-top: 0.1rem solid #e5e5e5;
      .save-content .save-item {
        border: none;
        .cart-price {
          display: none !important;
        }
        .cart-left .cart-info {
          padding: 0rem 0 0 2rem !important;
        }
        .cart-left .cart-info .good-num {
          width: 80% !important;
        }
        .cart-left .cart-info .mb-remove {
          display: block !important;
        }
        .cart-left .cart-info .good-price {
          display: block !important;
        }
      }
    }
  }
}
/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder,
.ivu-select-single .ivu-select-selection .ivu-select-selected-value {
  height: 2.4rem;
  line-height: 2.4rem;
  display: none;
}
/deep/.ivu-select-single .ivu-select-selection {
  width: 2.4rem;
  height: 2.4rem;
}
/deep/.ivu-select-placeholder {
  display: none !important;
}
/deep/.ivu-select-selected-value {
  display: none !important;
}

/deep/.ivu-select-arrow {
  right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/LoveList.vue